import { application } from "./application.js"
import axios from 'axios';

export class api {

    constructor(App) {
        /** @type {application} */
        this.App = App

        // globals

    }

    init() {

    }
    async post(url, data, headers) {

        // var headers = this.getHeaders();
        headers = headers === undefined ? {} : headers;
        // headers = {
        //     'content-type': 'application/json'
        // }

        try {
            var extra = '?XDEBUG_SESSION_START' //'' //
            let response = await axios({
                url: this.App.apiUrl + url + extra,
                method: 'POST',
                headers: headers,
                data: data,
                withCredentials: true,
            });

            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }

    }

    async get(url, headers) {
        // var headers = this.getHeaders();
        headers = headers === undefined ? {} : headers;

        try {
            var extra = '' // '?XDEBUG_SESSION_START' //'' //
            let response = await axios({
                url: this.App.apiUrl + url + extra,
                method: 'GET',
                headers: headers,
                withCredentials: true
            });

            return response.data;
        } catch (e) {
            console.error(e);
            throw e;
        }

        // var lib = this;
        // var xhttp = new XMLHttpRequest();
        // async = async === undefined ? true : async;
        // headers = headers === undefined ? {} : headers;
        // fncError = fncError === undefined ? function () { } : (typeof (fncError) === "function" ? fncError : function () { });

        // xhttp.open("GET", url, async);
        // xhttp.setRequestHeader('Accept', 'application/json');
        // for (var key in headers) {
        //     xhttp.setRequestHeader(key, headers[key]);
        // }
        // var onload = function () {
        //     response = {};

        //     if (xhttp.status === 200) {
        //         var response = JSON.parse(xhttp.response);
        //         lib.addCachedRequest(url, response);
        //         (fnc.bind(xhttp))(response);
        //     } else {
        //         if (lib.onError != undefined) lib.onError.call(xhttp);
        //         else fncError.call(xhttp);
        //     }
        //     return response;
        // };

        // if (async) xhttp.onload = onload;
        // if (!async) {
        //     var result = lib.getCachedRequest(url);
        //     if (result !== false) {
        //         (fnc.bind(xhttp))(result);
        //         return result;
        //     }
        // }
        // xhttp.send();
        // if (!async) return onload();
    }
}